import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, DataTablesService, MessageService, ButtonLoader, ConfigService } from '../../../../core';
import { ConfigEmpresa, isIdentificacaoRepresentanteNome } from '../../../configuracoes/app/empresa';
import { Representante, representanteAtivo, RepresentanteFilter, RepresentanteCrudHttpService, RepresentanteSearchHttpService } from '../../../pessoa/representante';
import { RepresentanteSearchOrderBy } from '../../../pessoa/representante/representante-search-orderby';
import { RegiaoRepresentante } from '../regiao-representante';
import { RegiaoRepresentantePopula } from './regiao-representante-popula';
import { RepresentanteSearchRepresentante, representanteSearchRepresentanteToRepresentante } from '../../../pessoa/representante/representante-search';

@Component({
    selector: 'sgt-regiao-representante-popula-modal',
    templateUrl: './regiao-representante-popula-modal.component.html',
    styleUrls: ['./regiao-representante-popula-modal.component.less']
})
export class RegiaoRepresentantePopulaModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;

    @Input() entities: RegiaoRepresentante[];
    @Input() idModal: string | 'RegiaoRepresentantePopulaModal';
    elModal: any;
    idDataTable = 'tablePopulaRepresentante';
    private dataTable: any;

    @ViewChild('form') form: NgForm;
    popula: RegiaoRepresentantePopula[] = [];
    allRepresentantesSelected: boolean;

    constructor(private el: ElementRef,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private representanteSearchHttpService: RepresentanteSearchHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        this.form.resetForm();
    }

    open() {
        this.clear();
        this.searchRepresentantes();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    showTable() {
        this.dataTablesService.showTable(jQuery(this.el.nativeElement).find(`#${this.idDataTable}`), this.dataTable, {
            paging: false,
            info: false,
            order: [[1, 'asc']],
            columnDefs: [
                {orderable: false, targets: 0},
            ],
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Pesquia os representantes ativos */
    private searchRepresentantes() {
        const representanteFilter = new RepresentanteFilter();
        representanteFilter.situacoes = [representanteAtivo.id];

        let orderBy: RepresentanteSearchOrderBy;
        if (isIdentificacaoRepresentanteNome(this.configEmpresa.identificacaoRepresentante)) {
            orderBy = RepresentanteSearchOrderBy.Nome;
        } else {
            orderBy = RepresentanteSearchOrderBy.NomeFantasia;
        }

        this.representanteSearchHttpService.search(representanteFilter, orderBy, 'asc', -1, -1)
            .subscribe(
                response => {
                    this.createPopula(response?.representantes ?? []);
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os representantes', error)
            );
    }

    /** Cria a listagem dos representantes para serem adicionadas na região */
    private createPopula(representantes: RepresentanteSearchRepresentante[]) {
        this.popula = [];
        if (!representantes) {
            return;
        }

        representantes.forEach(representanteSearch => {
            const entityPopula = new RegiaoRepresentantePopula();

            let entity = this.getRegiaoRepresentante(representanteSearch.id);
            if (entity) {
                entityPopula.exist = true;
            } else {
                entity = new RegiaoRepresentante();
                entity.idRepresentante = representanteSearch.id;
                entity.representante =  representanteSearchRepresentanteToRepresentante(representanteSearch);
            }
            entityPopula.regiaoRepresentante = entity;

            this.popula.push(entityPopula);
        });
    }

    /** Tenta obter o representante dentro dos representantes já adicionados na região*/
    private getRegiaoRepresentante(idRepresentante: number): RegiaoRepresentante {
        if (!idRepresentante || !this.entities) {
            return null;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (entity.idRepresentante === idRepresentante) {
                return entity;
            }
        }
        return null;
    }

    /** Ao alterar a opção de selecionar todos os representantes listados */
    onChangeAllRepresentantesSelected(value: boolean) {
        if (!this.popula) {
            return;
        }

        this.popula.forEach(entityPopula => {
            if (!entityPopula.exist) {
                entityPopula.selected = value;
            }
        });
    }

    /** Ao alterar o checkbox de um representante específico verificamos se todos estão selecionados */
    onChangeRepresentanteSelected() {
        let allSelected = true;
        for (let i = 0; i < this.popula.length; i++) {
            const entityPopula = this.popula[i];
            if (!entityPopula.selected) {
                allSelected = false;
                break;
            }
        }
        this.allRepresentantesSelected = allSelected;
    }

    selectRepresentante(entity: RegiaoRepresentantePopula) {
        if (!entity) {
            return;
        }

        // Somente se ainda não estiver adicionando
        if (!entity.exist) {
            entity.selected = !entity.selected;
            this.onChangeRepresentanteSelected();
        }
    }


    /** Adiciona os representantes selecionados e que ainda não estão adicionas à região */
    adicionar() {
        if (!this.popula) {
            this.close();
            return;
        }

        const btnAdicionar = new ButtonLoader('#btnAdicionar');
        btnAdicionar.loading('Adicionando');
        this.popula.forEach(entityPopula => {
            if (entityPopula.selected && !entityPopula.exist) {
                this.entities.push(entityPopula.regiaoRepresentante);
            }
        });

        btnAdicionar.reset();
        this.close();
    }
}
